export const MINUTE_IN_MS = 60000;
